import hous from "../assets/img/home.jpg";
import kabina from "../assets/img/kabina.jpg";
import olma from "../assets/img/olma.jpg";
import algo from "../assets/img/algo.jpg";

export const allProjects = [
  {
    id: 1,
    name: "Houzing",
    image: hous,
    link: "https://houzing-demo.netlify.app/",
  },
  {
    id: 2,
    name: "Algoritm Edu",
    image: algo,
    link: "https://algoritm21.uz",
  },
  {
    id: 3,
    name: "Mussafo",
    image: kabina,
    link: "https://olma-uz-frontend.vercel.app",
  },
  {
    id: 4,
    name: "Olma.uz",
    image: olma,
    link: "https://olma-uz-frontend.vercel.app",
  },
];
